import { render } from "./DataSourcesOnvif.vue?vue&type=template&id=17bb6ec2&ts=true"
import script from "./DataSourcesOnvif.vue?vue&type=script&lang=tsx"
export * from "./DataSourcesOnvif.vue?vue&type=script&lang=tsx"

import "./DataSourcesOnvif.vue?vue&type=style&index=0&id=17bb6ec2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__